import React, { useState, useEffect } from 'react'
//import MultiverXChat from 'multiverx-chat';
import './xchat.scss'
import './multiverxchat.scss'
import { AuthManager } from 'spark-core-dx/managers'

const XChat = ({ }) => {
    const authProvider = AuthManager.getAuthProvider();
    const token = AuthManager.getTokens().Access;

    return (
        <div className="multiverXChat">
            <div className="XChat-landing">
                {authProvider.AuthProvider === 1 ?
                /*<MultiverXChat
                        settings={{
                        apiBaseUrl: "http://localhost:8000/api/v1",
                        apiAuthBaseUrl: "http://localhost:8000/api/v1/auth",
                        theme: "light"
                        }}
                        externalToken={token}
                    />*/ 
                     <div>Comming Soon</div> : <div>Microsoft 365 single sign on is required by MultiverX Chat. Please contact support for more details.</div>
                }
            </div>
        </div>
    )

}

export default XChat;



